// 公司公证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let corp = get(state, 'currentContractorDetail.contractorInfo.docInfo.corp', {})
  return {
    title: i18n.gettext('公司公证'),
    content: [
      // {
      //   title: i18n.gettext('公共契约编号'),
      //   label: corp.contractNum
      // },
      // {
      //   title: i18n.gettext('公证编号和地区'),
      //   label: corp.notaryNum
      // },
      // {
      //   title: i18n.gettext('公证日期'),
      //   content: corp.notaryDate
      // },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: corp.licensePics
      }
    ]
  }
}
